import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Table.css";
import Navbar from "../Navbar/Navbar";
// import profile from "../../image/profile.png";
// import find from "../../image/find.png";
// import arrow from "../../image/arrow.png";
import Edit from "../../image/edit4.png"; //HERE ALEX HERE
import Save from "../../image/save6.png"; //ALSO HERE ALEX HERE
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import Config from "../../utils/Config";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const bgDanger = "#ff6384"; // Red color for weekly average
const bgWarning = "#FFCE56";
const bgSuccess = "#5796c3";

function getCurrentMonthTotalDays() {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const totalDays = new Date(currentYear, currentMonth + 1, 0).getDate();

  return totalDays;
}

function getProgressBarColor(value) {

  //Calculate percentage based on the same formula
  const percentage = Math.min(100, Math.round((value * 100) / 30));

  if (percentage < 15) {
    return bgDanger; // Red color for values less than 4
  } else if (percentage < 30) {
    return bgWarning; // Yellow color for values between 4 and 8
  } else {
    return bgSuccess; // Green color for values greater than or equal to 8
  }
}

function getComplianceBarColor(value) {

  //Calculate percentage based on the same formula

  if (value < 20) {
    return bgDanger; // Red color for values less than 4
  } else if (value < 30) {
    return bgWarning; // Yellow color for values between 4 and 8
  } else {
    return bgSuccess; // Green color for values greater than or equal to 8
  }
}

const Table = () => {
  // const [patients, setPatients] = useState([]);
  const patients = useRef([]);
  const [currentPage, setCurrentPage] = useState(1);
  // const patientsPerPage = 5;
  const navigate = useNavigate();
  // const totalDaysInCurrentMonth = getCurrentMonthTotalDays();
  const [isLoading, setIsLoading] = useState(true);

  // const [filteredPatients, setFilteredPatients] = useState([]);
  // const [searchQuery, setSearchQuery] = useState("");
  // const [showDropdown, setShowDropdown] = useState(false);
  // const [selectedPatient, setSelectedPatient] = useState([0]);
  // const [startTime, setStartTime] = useState(new Date());
  // const [previousPatientId, setPreviousPatientId] = useState(null);

  // you can change the rows per page for your table from here
  const rowsPerPage = 10;
  const notifyError = (text) => toast.error(text);
  var notified = false;

  const token = localStorage.getItem("token");

  var [edited, setEdited] = useState(0);
  const lastEdited = useRef(-1);

  var indexOfLastPatient = currentPage * rowsPerPage;
  var indexOfFirstPatient = indexOfLastPatient - rowsPerPage;
  //const [currentPatients, setCurrentPatients] = useState([]);
  const currentPatients = useRef([]);

  useEffect(() => {
    setTimeout(function () {
      fetchData();
    }, 20);
  });

  const fetchData = async () => {
    try {
      const response = await axios.post(
        `${Config.API_URL}/data/all_patients`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = JSON.parse(response.data);
      // setPatients(data);
      patients.current = data;
      currentPatients.current = data.slice(
        indexOfFirstPatient,
        indexOfLastPatient
      );
      //setCurrentPatients(data.slice(indexOfFirstPatient, indexOfLastPatient));

      setIsLoading(false);

      // console.log(data)

      // var element = document.getElementById("email_toggle");
      // element.addEventListener("change", function (event) {
      //     if (event.target.checked) {
      //         console.log("Checked");
      //     } else {
      //         console.log("Not checked");
      //     }
      // });

      //setIsLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate("/login");
      }

      if (error.response && error.response.status === 404) {
        patients.current = [];
        currentPatients.current = [];
        if (notified === false) {
          notifyError("No patients found");
          notified = true;
        }

        //navigate("/login");
        setIsLoading(false);
      }
    }
  };

  // const handleSearchInputChange = (e) => {
  //   const query = e.target.value;
  //   setSearchQuery(query);
  //   filterPatients(query);
  //   setShowDropdown(query !== "");
  // };

  // const filterPatients = (query) => {
  //   const filtered = patients.filter((patient) =>
  //     patient.full_name.toLowerCase().includes(query.toLowerCase())
  //   );
  //   console.log(filtered)
  //   setFilteredPatients(filtered);
  // };

  // const listAllPatients = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${Config.API_URL}/data/list_patients`,
  //       {},
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     let data = JSON.parse(response.data);
  //   } catch (error) {
  //     notifyError(error.response.data.detail);
  //   }
  // };

  // const handleSelectPatient = (patient) => {
  //   setSearchQuery(patient.full_name);

  //   setSelectedPatient(patient);

  //   localStorage.setItem("startTime", startTime);
  //   localStorage.setItem("SelectedPatient", patient.full_name);

  //   setFilteredPatients([]);
  //   setPreviousPatientId(patient.id);
  //   setSearchQuery("");
  //   setShowDropdown(false);
  //   localStorage.setItem("previousPatientID", patient.id);
  // };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    indexOfLastPatient = pageNumber * rowsPerPage;
    indexOfFirstPatient = indexOfLastPatient - rowsPerPage;
    currentPatients.current = patients.current.slice(
      indexOfFirstPatient,
      indexOfLastPatient
    );
    setCurrentPage(pageNumber);
  };

  const name_clicked = (name) => {
    // console.log(name)
    localStorage.setItem("SelectedPatient", name);
    localStorage.setItem("startTime", new Date());
    return true;
  };

  const edit_name = (index, patient) => {
    if (lastEdited.current !== index && edited === 1) {
      return;
    }

    if (edited === 0) {
      const name = document.getElementById("name_field_" + index);
      name.setAttribute("contentEditable", "true");

      const fix_name = document
        .getElementById("name_field_" + index)
        .getElementsByTagName("a")[0];
      name.innerHTML = fix_name.innerText;

      try {
        const edit_icon = document.getElementById("edit_icon_" + index);
        edit_icon.setAttribute("src", Save);
      } catch {
        console.log("err");
      }

      lastEdited.current = index;

      setEdited(1);
    }

    var old_name = patient.full_name;
    var new_name = "";

    if (edited === 1) {
      //<a href="/dashboard">Karen Fidance</a>sdfsd
      try {
        var name = document.getElementById("name_field_" + index);
        new_name = name.innerHTML;
        new_name = new_name.replace(/&nbsp;/g, "").trim();

        patient.full_name = new_name;

        name.setAttribute("contentEditable", "false");
        name.innerHTML = "<a id=name_link_" + index + ">" + new_name + "</a>";

        var name_link = document.getElementById("name_link_" + index);
        name_link.href = "/dashboard";
        name_link.onclick = function () {
          name_clicked(patient.full_name);
        }; // for IE

        var edit_icon = document.getElementById("edit_icon_" + index);
        edit_icon.setAttribute("src", Edit);

        lastEdited.current = -1;

        if (new_name !== old_name) {
          change_name(patient, old_name, new_name);
        }
      } catch (error) {
        console.log(error);
      }
      setEdited(0);
    }
  };

  const change_name = async (patient, old_name, new_name) => {
    let formData = new FormData();
    formData.append("patient_id", patient.id);
    formData.append("new_name", new_name);
    formData.append("old_name", old_name);

    // console.log(patient.id, new_name)

    try {
      await axios
        .post(`${Config.API_URL}/set_new_name`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          toast.success("Changed Name Succesfully");
        })
        .catch((error) => {
          toast.error(error.response.data.detail.msg);
        });
    } catch (error) {
      toast.error("Error saving name");
    }
  };

  const change_tracking = async (patient, tracking_status) => {
    let formData = new FormData();
    formData.append("patient_id", patient.id);

    formData.append("new_tracking", tracking_status);

    // console.log(patient.id, new_name)

    try {
      await axios
        .post(`${Config.API_URL}/set_tracking`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          toast.success("Changed Tracking Status Succesfully");
        })
        .catch((error) => {
          toast.error(error.response.data.detail.msg);
        });
    } catch (error) {
      toast.error("Error saving tracking status");
    }
  };

  const edit_email = (index, patient) => {
    
    //code here to turn off email reporting
    // console.log("clicked toggle")

    var toggle_button = document.getElementById("email_toggle_"+String(index));

    var button_status = 1;

    // console.log(toggle_button.checked)

    if(toggle_button.checked === false){
      // console.log("turning off")
      button_status = toggle_button.checked ? 1 : 0;
    }
    else if (toggle_button.checked === true){
      // console.log("turning on")
      button_status = toggle_button.checked ? 1 : 0;
    }

    change_tracking(patient, button_status)
    // console.log(toggle_button.checked)
  }

  return (
    <div>
      {isLoading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div>
          <Navbar/>
          <div className="container-fluid">
            <Toaster position="top-center" reverseOrder={false} />
            <div className="table_data">
              <div className="pagination_and_search">
                <h4>Your Patients</h4>
              </div>
              <div className="table_area">
                <table>
                  <thead>
                    <tr key="header">
                      <th>Index</th>
                      <th>Name</th>
                      <th>Program</th>
                      <th>Location</th>
                      <th>Age</th>
                      <th>Start Date</th>
                      <th>Today's Steps</th>
                      <th>Track</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody id="patients_table">
                    {currentPatients.current.map((patient, index) => (
                      <tr key={index}>
                        <td>&nbsp; {indexOfFirstPatient + index + 1}</td>

                        <td id={"name_field_" + index} contentEditable="false">
                          <a
                            href="/dashboard"
                            id={"name_link_" + index}
                            onClick={() => name_clicked(patient.full_name)}
                          >
                            {patient.full_name}
                          </a>
                        </td>
                        <td>{patient.program}</td>
                        <td>{patient.location}</td>
                        <td>{patient.age}</td>
                        <td>
                          {
                            new Date(patient.start_date)
                              .toLocaleString()
                              .split(",")[0]
                          }
                        </td>
                        <td>{patient.steps}</td>
                        <td>
                          <label className="switch">
                            <input type="checkbox" 
                            id={"email_toggle_"+index}
                            defaultChecked={patient.tracking}
                            onChange={() => edit_email(index, patient)}/>
                            <span className="slider round"></span>
                          </label>
                        </td>
                        <td>
                          <img
                            id={"edit_icon_" + index}
                            src={Edit}
                            style={{ width: "20px", height: "20px" }}
                            onClick={() => edit_name(index, patient)}
                            alt=""
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="paginatin_sec">
                <ul>
                  Page &nbsp;
                  {Array(Math.ceil(patients.current.length / rowsPerPage))
                    .fill()
                    .map((_, index) => (
                      <li key={-1}>
                        <Link
                          className={`page ${
                            currentPage === index + 1 ? "current" : ""
                          }`}
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>

            <div className="progress_container">
              <div className="progress_bar_file">
                <div className="progress_heading">
                  <h4>Overall Compliance</h4>
                </div>
                <div className="progress_grid">
                  {patients.current.map((patient, index) => (
                    <div className="progress_item" key={index}>
                      <div className="tableName">{patient.full_name}</div>
                      <div className="circularProgress">
                        <CircularProgressbar
                          value={patient.compliance_rate}
                          text={`${Math.min(
                            100,
                            patient.compliance_rate.toFixed(0)
                          )}%`}
                          styles={buildStyles({
                            textSize: "16px",
                            pathColor: getComplianceBarColor(
                              patient.compliance_rate
                            ),
                            textColor: "#000",
                            trailColor: "#e0e0e0",
                            strokeLinecap: "round",
                          })}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="progress_bar_file">
                <div className="progress_heading">
                  <h4>Billing Readiness</h4>
                </div>
                <div className="progress_grid">
                  {patients.current.map((patient, index) => (
                    <div className="progress_item" key={index}>
                      <div className="tableName">{patient.full_name}</div>
                      <div className="circularProgress">
                        <CircularProgressbar
                          value={(patient.billing) * 100 / 30}
                          text={`${Math.min(
                            100,
                            ((patient.billing) * 100 / 30).toFixed(0)
                          )}%`}
                          styles={buildStyles({
                            textSize: "16px",
                            pathColor: getProgressBarColor(patient.billing),
                            textColor: "#000",
                            trailColor: "#e0e0e0",
                            strokeLinecap: "round",
                          })}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      )}{" "}
    </div>
  );
};

export default Table;
